import { Selector } from "@ngxs/store";

import { VehicleState, VehicleStateModel } from "./vehicle.state";
import { LogModel, Vehicle } from "../../core/models";
import { LogGetterState } from "../log";
import { CostCentreGetterState } from "../cost-centre";
import { CostCentre } from "../../core/models/cost-centre.model";
import { IRequestsNestedState } from "../interfaces/requests.interface";

export class VehicleGetterState {
  @Selector([VehicleState])
  static getVehicleState(state: VehicleStateModel): VehicleStateModel {
    return state;
  }

  @Selector([VehicleState])
  static getVehicles(state: VehicleStateModel): Vehicle[] {
    return state.ids.map((id) => state.entities[id]);
  }

  @Selector([VehicleState])
  static getCustomerVehicles(state: VehicleStateModel): Vehicle[] {
    return state.customerVehiclesIds.map((id) => {
      const vehicle: Vehicle = { ...state.entities[id] };
      const isRegoAndName: string = vehicle.vehDriver && vehicle.vehRegoNo;
      const singleText: string =
        vehicle.vehRegoNo || vehicle.vehDriver || vehicle.vehVehicleSerial;
      vehicle.displayText = isRegoAndName
        ? `${vehicle.vehRegoNo} (${vehicle.vehDriver})`
        : singleText;
      return vehicle;
    });
  }

  @Selector([
    VehicleGetterState.getCustomerVehicles,
    LogGetterState.getLiveLogsGroupedByVehicle,
  ])
  static getInactiveCustomerVehicles(
    vehicles: Vehicle[],
    logsArr: LogModel[][]
  ): Vehicle[] {
    if (!logsArr?.length) {
      return;
    }

    const inactiveCars: Vehicle[] = vehicles.filter((vehicle) => {
      return !logsArr.find((logs) =>
        logs.find((log) => log.logVehicleId === vehicle.vehVehicleId)
      );
    });
    return inactiveCars;
  }

  @Selector([
    VehicleGetterState.getCustomerVehicles,
    CostCentreGetterState.getCostCentres,
  ])
  static getCustomerVehiclesWithCostCentreName(
    vehicles: Vehicle[],
    costCentres: CostCentre[]
  ): Array<Vehicle & { costCentreName: string }> {
    return vehicles.map((vehicle) => {
      const costCentre = costCentres.find(
        (centre) => centre.costCentreId === vehicle.vehCostCentreId
      );

      return {
        ...vehicle,
        costCentreName: costCentre?.costCentreName,
      };
    });
  }

  @Selector([VehicleState])
  static getCustomerVehiclesRequestState(
    state: VehicleStateModel
  ): IRequestsNestedState {
    return state.customerVehiclesRequestState;
  }
}
